import StandardResponse from 'models/standard-response';
import BaseService from 'services/base-service';
import type { IConfigurationDetail, IConfigurationSearchParams } from 'models/common';

export const getConfigurationDetail = async (data: IConfigurationSearchParams) => {
    try {
        const res = await BaseService({
            url: `web-pay/configuration/public/search`,
            method: 'POST',
            data: { ...data, hideSpinner: true },
        });
        return new StandardResponse<IConfigurationDetail[]>(res.status, res.data.data, res.data.message, null);
    } catch (e) {
        return Promise.reject(e);
    }
};
